import { useBehavior } from '@libs/hooks';
import { TCommonData, TWidgetProps } from '@libs/types';
import React from 'react';
import { TCoreImageOptions } from '../types/options';
import { CoreImageView } from './CoreImageView';

/**
 * Standalone image widget driven entirely by server-provided configuration.
 * Owns behavior hooks (useBehavior) and delegates rendering to CoreImageView.
 *
 * Use this component when the widget definition comes from the server and no
 * additional style overrides are required.
 */
const CoreImageWidget = ({ widget }: TWidgetProps<TCommonData, TCoreImageOptions>) => {
    const { isHidden } = useBehavior(widget);
    const src = widget.data?.value && typeof widget.data.value === 'string' ? widget.data.value : '';

    return <CoreImageView widget={widget} isHide={isHidden} src={src} styleName={widget.options?.style} />;
};

export { CoreImageWidget };
